const GraveIcon = ({ size = 20, color = '#7BB9F5' }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none">
    <path
      d="M4.81875 0.00156405C4.99921 -0.0187241 5.248 0.161745 5.22131 0.346474C5.19782 0.504508 4.83477 0.838719 4.72692 0.991414C2.04781 4.82801 5.57582 9.52205 9.99116 8.05704C10.2464 7.97268 10.933 7.49965 11.0162 8.00578C11.0696 8.33466 10.4759 9.12697 10.2506 9.39071C6.83475 13.3907 0.277409 11.1376 0.00618859 5.9097C-0.132625 3.22632 2.08198 0.299492 4.81982 0.000508249L4.81875 0.00156405Z"
      fill={color}
    />
  </svg>
);

export {GraveIcon};